import { notificationService } from "../services/notification.service";
import { activeLoader, setLicenseExpireFlag, setUnregisterdUserMessage } from "./view.actions";
import { GetNotificationRequiredInfo, NotificationModal, UserConfigModal } from "../modal/notification";
import { DeleteRequestInfo } from "../modal/narrative-board";
import { cardLibraryService } from "../services/card-library.service";
import { CONFIG } from "../helper/config";

export const notificationActions = {
    SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
    UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
    SET_CARD_HTML: 'SET_CARD_HTML',
    SET_NOTIFICATION_MESSAGE: 'SET_NOTIFICATION_MESSAGE',
    SET_HOME_VA_DATA:'SET_HOME_VA_DATA',
    SET_VA_DETAILS:'SET_VA_DETAILS'
};

/**
 * calls getNotifications service to get notifications
 */
export const getNotifications = (info: GetNotificationRequiredInfo, auth_token:string, is_loader_active: boolean = true) => (dispatch: (arg0: any) => void) => {
    if (is_loader_active) {
        dispatch(activeLoader(true));
    }
    notificationService.getNotification(info, auth_token).then((result) => {
        dispatch(setNotifications(result));
        dispatch(activeLoader(false));
    }).catch((error: any) => {
        dispatch(setNotificationMessage(error))
        dispatch(handleCatch(error));
    })
}

/**
* update notifications to  store
*/
export const setNotifications = (notifications: NotificationModal[]) => (dispatch: (arg0: { type: string; payload: { notifications: any; }; }) => void) => {
    dispatch({
        type: notificationActions.SET_NOTIFICATIONS,
        payload: { notifications: notifications },
    });
};

export const createNotification = (info: any, auth_token:string)=>(dispatch: (arg0: any) => void)=>{
    dispatch(activeLoader(true));
    notificationService.createNotification( info, auth_token).then((result) => {
        dispatch(setNotificationMessage(CONFIG.NOTIFICATION.SUCCESS));
        dispatch(activeLoader(false));
    }).catch((error: any) => {
        dispatch(handleCatch(error));
    })
}

/**
 * calls editNotifications service to edit notification
 */
export const editNotification = (notification_id: number, info: any, auth_token:string,target:string) => (dispatch: (arg0: any) => void) => {
    dispatch(activeLoader(true));
    notificationService.editNotification(notification_id, info, auth_token).then((result) => {
        dispatch(updateNotification(result));
        dispatch(activeLoader(false));
        if(target==='edit-notification'){
            dispatch(setNotificationMessage(CONFIG.NOTIFICATION.SUCCESS));
        }
    }).catch((error: any) => {
        dispatch(handleCatch(error));
    })
}

/**
* update notification state to  store
*/
export const updateNotification = (notification: any) => (dispatch: (arg0: { type: string; payload: { notification: any; }; }) => void) => {
    dispatch({
        type: notificationActions.UPDATE_NOTIFICATION,
        payload: { notification: notification },
    });
};

/**
 * calls deleteNotifications service to delete notification
 */
export const deleteNotification = (notification_id: number,delete_info: DeleteRequestInfo, info: GetNotificationRequiredInfo, auth_token: string) => (dispatch: (arg0: any) => void) => {
    dispatch(activeLoader(true));
    notificationService.deleteNotification(notification_id, delete_info, auth_token).then((result) => {
        dispatch(getNotifications(info, auth_token, false));
    }).catch((error: any) => {
        dispatch(handleCatch(error));
    })
}


/**
 * calls deleteNotifications service to delete notification
 */
export const getCardHTML = (notification_id: number, port_no: string, teams_context: any, auth_token:string,platform:string) => (dispatch: (arg0: any) => void) => {
    dispatch(activeLoader(true));
    let user_config_keys : UserConfigModal = {tenant_id: teams_context.tid,
        team_id:(teams_context.groupId) ? teams_context.groupId : '',
        channelId: teams_context.channelId,
        platform:platform ?? "teams",
        user_id: teams_context.userObjectId};
        notificationService.getCard(notification_id, user_config_keys, auth_token).then((result) => {
        let info = {
            user_id: teams_context.userObjectId,
            user_name: teams_context.userPrincipalName,
            tenant_id: teams_context.tid,
            platform:platform ?? "teams",
            file_name: result.file_name,
            va_id: result.va_id,
            port_no:port_no
        }
       
        dispatch(getCardHTMLContent(info, auth_token));
       
    }).catch((error: any) => {
        dispatch(setNotificationCardHTML({}));
        dispatch(handleCatch(error));
    })
}

export const getCardHTMLContent = ( info: any, auth_token:string) => (dispatch: (arg0: any) => void) => {
    cardLibraryService.getTeamCard(info, auth_token).then((result) => {
        dispatch(setNotificationCardHTML(result));
        dispatch(activeLoader(false));
    }).catch((error: any) => {
        dispatch(setNotificationCardHTML({}));
        dispatch(handleCatch(error));
    })
}

/**
* update notification card image state to  store
*/
export const setNotificationCardHTML = (card_html: any) => (dispatch: (arg0: { type: string; payload: { card_html: any; }; }) => void) => {
    dispatch({
        type: notificationActions.SET_CARD_HTML,
        payload: { card_html: card_html },
    });
};

/**
* update notification message state to  store
*/
export const setNotificationMessage = (msg: string) => (dispatch: (arg0: { type: string; payload: { notification_msg: string; }; }) => void) => {
    dispatch({
        type: notificationActions.SET_NOTIFICATION_MESSAGE,
        payload: { notification_msg: msg },
    });
};

/**
 * Handles errors that occur during notification service operations.
 *
 * @param {any} error - The error object to be handled.
 *
 * Dispatches actions to update the loader state and set appropriate error messages
 * based on the type of error received. Logs the error to the console.
 * Specifically handles errors related to unregistered users, license expiry,
 * and other general errors by updating the notification message.
 */

const handleCatch = (error: any)=>(dispatch: (arg0: any) => void)=>{
    dispatch(activeLoader(false));
    console.error(error);
    if(error.demo){
        dispatch(setUnregisterdUserMessage(error.demo , error.msg))
    }else if(error.expiry){
        dispatch(setLicenseExpireFlag(true));
    }else if(error.msg){
        dispatch(setNotificationMessage(error.msg));
    }
    else{
        error = typeof error === 'string' ? error : CONFIG.API.ERRORMESSAGE.FAILEDTOFATCH;
        dispatch(setNotificationMessage(error));
      }
}

/**
 * Calls getHomeVas service to get home virtual assistants data
 * 
 * @param {any} info - The request info containing tenant and team identifiers.
 * @param {string} auth_token - The authentication token for API requests.
 * 
 * If the result contains va_details, it dispatches an action to fetch the details of the first virtual assistant.
 * Dispatches an action to set the home virtual assistants data in the store.
 * Handles any errors that occur during the fetching process.
 */
export const getHomeVas = ( info: any, auth_token:string) => (dispatch: (arg0: any) => void) => {
    dispatch(activeLoader(true))
    notificationService.getHomeVas(info, auth_token).then((result) => {
        if(result.va_details.length>0){ 
       dispatch(getVADetails({...info,"va_id":result.va_details[0].va_id},auth_token))
        }
       dispatch(setHomeVAsData(result))
       dispatch(activeLoader(false));
    }).catch((error: any) => {
        dispatch(handleCatch(error));
    })
}

/**
 * Updates the home virtual assistants data in the store.
 * 
 * @param {any} va_data - The virtual assistants data to be set in the store.
 * Dispatches an action to update the home_va_data state with the provided data.
 */

export const setHomeVAsData = ( va_data: any) => (dispatch: (arg0: { type: any; payload: { home_va_data: any; }; }) => void) => {
    dispatch({
        type: notificationActions.SET_HOME_VA_DATA,
        payload: { home_va_data: va_data},
    });
};

/**
 * Calls getVADetails service to get the details of a virtual assistant.
 * 
 * @param {any} info - The request info containing tenant and team identifiers, and the virtual assistant identifier.
 * @param {string} auth_token - The authentication token for API requests.
 * 
 * Dispatches an action to set the virtual assistant details in the store.
 * Handles any errors that occur during the fetching process.
 */
export const getVADetails = ( info:any, auth_token:string) => (dispatch: (arg0: any) => void) => {
    dispatch(activeLoader(true))
    notificationService.getVADetails(info,auth_token).then((result) => {
       dispatch(setVADetails(result))
       dispatch(activeLoader(false));
    }).catch((error: any) => {
        dispatch(handleCatch(error));
    })
}

export const updateAgentStatus = ( va_info:any, auth_token:string,home_va_info:any) => (dispatch: (arg0: any) => void) => {
    dispatch(activeLoader(true))
    notificationService.updateAgentStatus(va_info,auth_token).then((result) => {
    //    dispatch(setVADetails(result))
         dispatch(getHomeVas(home_va_info,auth_token))
         dispatch(activeLoader(false));
     }
    ).catch((error: any) => {
        dispatch(handleCatch(error));
    }
    )
}

/**
 * Updates the virtual assistant details in the store.
 * 
 * @param {any} va_data - The virtual assistant details to be set in the store.
 * Dispatches an action to update the va_details state with the provided data.
 */
export const setVADetails = ( va_data: any) => (dispatch: (arg0: { type: any; payload: { va_details: any; }; }) => void) => {
    dispatch({
        type: notificationActions.SET_VA_DETAILS,
        payload: { va_details: va_data},
    });
};